module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/hotel.svg?82ec45a96dd8011c2cb8ab04df0b4d84";